import { render, staticRenderFns } from "./rollNumber.vue?vue&type=template&id=8e223c84&"
import script from "./rollNumber.vue?vue&type=script&lang=js&"
export * from "./rollNumber.vue?vue&type=script&lang=js&"
import style0 from "./rollNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports